import React from "react";

export function EditIcon(): React.ReactElement {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9842 4.8101C19.3417 5.1433 19.3417 5.68156 18.9842 6.01476L17.3067 7.57826L13.8692 4.37437L15.5467 2.81088C15.9042 2.47767 16.4817 2.47767 16.8392 2.81088L18.9842 4.8101ZM2.75 17.9418V14.7379L12.8883 5.28855L16.3258 8.49243L6.1875 17.9418H2.75Z"
        fill="#DD2E6F"
      />
    </svg>
  );
}
